<template>
  <div>
    <CoverBg
      show-text
      title="Clinical Expertise"
      text="From clinical research, trial phases to ISS & ISE services to name but a few"
    />
    <b-container class="main-container content-padding-t-b-100">
      <b-row>
        <b-col
          v-for="(expertise, i) in clientExpertises"
          :key="i"
          cols="12"
          class="p-0 with-hover cursor-pointer"
          :class="{'m-b-50' : i !== clientExpertises.length - 1}"
          @click="showModal(i)"
        >
          <ExpertiseItems
            :item="expertise"
            :idx="i"
          />
        </b-col>
      </b-row>
    </b-container>
    <ExpertiseItemModal
      v-if="modalItem"
      :visible="show"
      :modal-item="modalItem"
      @hide-modal="hideModal"
    />

    <CoverBg
      bg="cover-bg-page-bottom"
    />
  </div>
</template>

<script>
import CoverBg from '@/components/CoverBg';
import ExpertiseItems from '@/components/Expertise/ExpertiseItems';
import clientExpertises from '@/constants/ClientExpertise/clientExpertises';
import ExpertiseItemModal from '@/components/Expertise/ExpertiseItemModal';

export default {
  name: 'ClientExpertise',
  components: { ExpertiseItemModal, ExpertiseItems, CoverBg },
  data() {
    return {
      clientExpertises,
      modalItem: null,
      show: false,
    };
  },
  methods: {
    showModal(i) {
      this.modalItem = {
        index: i,
        ...clientExpertises.find((el, idx) => i === idx),
      };
      this.show = true;
    },
    hideModal() {
      this.show = false;
    },
  },
};
</script>
